import endsWith from 'lodash/endsWith';
import { HOT_LEVEL } from '@/constants/job-ranking';

export const renameL1Name = (id: string, name: string) => {
  return id === HOT_LEVEL.id ? '' : endsWith(name, '类') ? name : name + '类';
};
